export default __webpack_public_path__ + "static/pie-0410cc040854ea0552416828cda86348.png";